"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Use in the default clause of a switch statement for a compile-time check that all the cases have been covered
 */
function assertUnreachable(_) {
    return;
}
exports.assertUnreachable = assertUnreachable;
function filterOutNullAndUndefined(arr) {
    return arr.filter(function (t) { return t !== null && t !== undefined; });
}
exports.filterOutNullAndUndefined = filterOutNullAndUndefined;
//# sourceMappingURL=TypescriptHelpers.js.map